import React from 'react';

export default function TermsButton() {
	return (
		<a className="Button primary" href="https://hjelp.lovdata.no/article/245-kundeavtale-for-lovdata-pro">
			<span>Avtalevilkår for Lovdata Pro</span>
		</a>
	);
}
